import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIconists: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="iconists"><path d="M12 2V22L8 20V4L12 2Z" fill="currentColor"/><path opacity="0.35" d="M16 4V20L12 22V2L16 4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconIconists;
